import { apiClient } from './client';
import type { RendererResponse } from '../types/pagePayload';

function currentWebsiteDomain(): string {
  let hostname = window.location.hostname.toLowerCase();
  if (hostname.startsWith('preview.')) hostname = hostname.slice('preview.'.length);
  if (hostname.startsWith('www.')) hostname = hostname.slice('www.'.length);
  return hostname;
}

export async function resolvePage(pathname: string): Promise<RendererResponse> {
  const websiteDomain = currentWebsiteDomain();

  console.log('[Renderer resolvePage]', {
    pathname,
    browserHostname: window.location.hostname,
    websiteDomain,
    apiBaseURL: import.meta.env.VITE_API_BASE_URL,
    endpoint: '/web',
  });

  const response = await apiClient.get<RendererResponse>('/web', {
    params: { path: pathname },
    headers: { 'X-Website-Domain': websiteDomain },
  });

  console.log('[Renderer resolvePage response]', response.data);
  return response.data;
}
